var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElipce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.64 64C127.64 99.1471 99.1471 127.64 64 127.64C28.8528 127.64 0.360352 99.1471 0.360352 64C0.360352 28.8528 28.8528 0.360352 64 0.360352C99.1471 0.360352 127.64 28.8528 127.64 64ZM19.4522 64C19.4522 88.603 39.3969 108.548 64 108.548C88.603 108.548 108.548 88.603 108.548 64C108.548 39.3969 88.603 19.4522 64 19.4522C39.3969 19.4522 19.4522 39.3969 19.4522 64Z",
    fill: "#2AA444"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElipce);
export default __webpack_public_path__ + "static/media/elipce.f20ccf7a4e2fcbf11688be5f8e80aa4b.svg";
export { ForwardRef as ReactComponent };